import { render, staticRenderFns } from "./ClaimDetailByOwner.vue?vue&type=template&id=e7b88248&"
import script from "./ClaimDetailByOwner.vue?vue&type=script&lang=js&"
export * from "./ClaimDetailByOwner.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDetailByOwner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports